import React from 'react'
import {useHeaderContent} from '../../contexts'
import CMSContent from '../cms-content'
import InteractionStudioContent from '../interaction-studio/content'

const HeaderContent = () => {
    const headerContent = useHeaderContent()
    return (
        <InteractionStudioContent id="is-header-content">
            <CMSContent content={headerContent} id="header-content" showError={false} />
        </InteractionStudioContent>
    )
}

export default HeaderContent
